<template>
    <section class="esesja-modal">
        <section class="esesja-modal__wraper">
            <section class="esesja-modal__wraper__header">
                <h3 class="esesja-modal__wraper__header__title">{{$t('com.file.interactive-voting-block-results-modal.voting-block-results')}}</h3>
                <button class="esesja-modal__wraper__header__exit-btn" @click="closeModale">
                    <img src="../../../../../assets/icons/components/exit-btn.svg" />
                </button>
            </section>
            <perfect-scrollbar class="esesja-modal__wraper__body">
                
                <ButtonWithIcon icon="download" class="download-button"
                                text=".PDF"
                                :classModified="true"
                                @click="getPdfReport()" />

                <div style="clear: both;" ref="pdf">
                    <section v-for="(item, index) in pointBlockVotingResults" :key="index" style="padding: 5px;">
                        <p class="voting-label">{{$t('com.file.excluded-users-modal.voting')}}: <b>{{item.name}}</b></p>
                        <table class="table-bootstrap table-bootstrap-sm table-bootstrap-bordered table-bootstrap-striped align-middle text-sm-center table-label">
                            <thead>
                                <tr>
                                    <th style="font-size: 14px;" v-for="i in item.results.sort((a, b) => (a.id > b.id) ? 1 : -1)" :key="i.id">{{i.name}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="align-middle">
                                    <td v-for="i in item.results.sort((a, b) => (a.id > b.id) ? 1 : -1)" :key="i.id">
                                        <span style="text-align: center;">
                                            {{i.count}}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </section>
                </div>
            </perfect-scrollbar>
        </section>
    </section>
</template>

<script>
    import ButtonWithIcon from "../../../../BasicControls/ButtonWithIcon.vue";
    import PdfExportService from "../../../../../services/pdf.export.service";
    import { fileDownloadHelperWithName } from "@/helpers/file.download.helper";

    export default {
        name: "InteractiveVotingBlockResultsModal",
        data() {
            return {

            };
        },
        components: {
            ButtonWithIcon
        },
        props: {
            pointBlockVotingResults: Array,
            pointIdForResults: Number,
            sessionId: Number
        },

        methods: {
            async getPdfReport() {
                try {
                    this.$store.commit("showLoader");

                    const result = await PdfExportService.getBlockVotingsResultsToPDfFIle(this.pointIdForResults, this.sessionId);
                    if (result.status === 200) {
                        var filename = result.headers['content-disposition'].split("filename=")[1];
                        filename = filename.substr(0, filename.indexOf(';'));
                        filename = filename.replaceAll('"', '');

                        fileDownloadHelperWithName(result, filename);
                    }
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },
            closeModale(e) {
                e.preventDefault();
                this.$emit('closePiontBlockVotingsResults');
            },
        },
    };
</script>

<style lang="scss" scoped>
    @use "../../../../../assets/scss/esesja-modal.scss";
    .voting-label {
        text-align: center;
        border: solid 1px;
    }

    .table-label {
        table-layout: fixed; 
        border: solid 1px;
    }

    .download-button {
        float: right;
        margin: 5px;
        padding: 10px;
    }

</style>
